import { env } from "~/env";
import CheckBox from "~/shared/components/ui/Checkbox/Checkbox";

interface LateCancellationFeeCardProps {
  waiveFee: boolean;
  onWaiveFeeChange: (waiveFee: boolean) => void;
}

/**
 * Shown only when the selected reason is patient-requested and the visit starts within the
 * late cancellation window. The waiver checkbox lives inside the card so the fee notice and
 * the decision about it read as one block.
 */
export const LateCancellationFeeCard = ({
  waiveFee,
  onWaiveFeeChange,
}: LateCancellationFeeCardProps) => (
  <div className="bg-lightYellow border-yellow text-dark-blue-gray flex flex-col gap-3 rounded-lg border p-4 text-sm">
    <p>
      This visit is within 24 hours of its scheduled time. A $
      {env.VITE_LATE_CANCELLATION_FEE} late cancellation / no show fee applies.
    </p>

    <CheckBox
      id="waiveFee"
      checked={waiveFee}
      onChange={(event) => onWaiveFeeChange(event.target.checked)}
      parentClassName="px-0"
      labelClassName="text-dark-blue-gray font-medium"
    >
      Waive fee
    </CheckBox>
  </div>
);
